// extracted by mini-css-extract-plugin
export default {"entities-container":"EntityList_entities-container__xYIoW","pagination-container":"EntityList_pagination-container__Fr9dd"};